// extracted by css-extract-rspack-plugin
export default {"root":"NotificationDate_root__g8z0+"};